import React from 'react';
import './TableNavBar.css';

const TableNavBar = ({ currentTable, onSelect }) => {
  const tables = [
    'Requests',
    'Users',
    'Chat_Message',
    'Location_Options',
    'Request_Options',
    'Officer_Driver_Options',
    'Announcements'
    // 'Refresh_Token'
  ];

  return (
    <div className="table-nav">
      {tables.map(table => (
        <button
          key={table}
          className={currentTable === table ? 'nav-button active' : 'nav-button'}
          onClick={() => onSelect(table)}
        >
          {table.replace(/_/g, ' ')}
        </button>
      ))}
    </div>
  );
};

export default TableNavBar;
